import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { MdDescription, MdCheckCircle, MdFormatListBulleted } from 'react-icons/md';
import WarrantiesList from './WarrantiesList';
import WarrantiesTemplatesList from './WarrantiesTemplatesList';
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import TabBar from '../../../shared/layout/tabs/TabBar';
import TabButton from '../../../shared/layout/tabs/TabButton';

const Warranties = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('active');

    return (
        <PageContainer>
            <PageHeader>
                <PageTitle icon={<MdDescription size={28} />}>{t('Warranties.title')}</PageTitle>
            </PageHeader>
            <PageContent>
                <TabBar>
                    <TabButton
                        active={activeTab === 'active'}
                        onClick={() => setActiveTab('active')}
                        icon={<MdCheckCircle />}
                    >
                        {t('Warranties.activeWarranties')}
                    </TabButton>
                    <TabButton
                        active={activeTab === 'templates'}
                        onClick={() => setActiveTab('templates')}
                        icon={<MdFormatListBulleted />}
                    >
                        {t('Warranties.warrantyTemplates')}
                    </TabButton>
                </TabBar>

                <div style={{ marginTop: '24px' }}>
                    {activeTab === 'active' && <WarrantiesList />}
                    {activeTab === 'templates' && <WarrantiesTemplatesList />}
                </div>
            </PageContent>
        </PageContainer>
    );
};

export default Warranties;
